<template>
    <div class="modal fade" id="branch_menu_modal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" id="sas" role="document">
            <div class="modal-content modal-lg">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="branchMenuModalLabel">Add / Update Branch Menu: {{branchName}}</h4>
                </div>
                <form method="post" @submit.prevent="updateBranchMenu()">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-2">
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(mCategory, indexMenuCategory) in menu" v-bind:key="indexMenuCategory">
                                        <a class="myTip"
                                           v-on:click="goToGivenCategory(indexMenuCategory)"
                                           :style="(mCategory.baykedExclusiveDeal) ? 'color: red;' : ''"
                                           v-bind:title="mCategory.name" >{{ (mCategory.name.length > 25) ? mCategory.name.substring(0,25)+'...' : mCategory.name}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-10">
                                <ul class="list-unstyled" id="menu_item_box">
                                    <li style="margin-bottom: 10px" class="col-md-12">
                                        <div class="btn-group pull-right">
                                            <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                                <div class="sk-bounce1"></div>
                                                <div class="sk-bounce2"></div>
                                                <div class="sk-bounce3"></div>
                                            </div>
                                            <button v-if="this.menu.length === 0" class="btn btn-success" type="button" v-on:click="copyFromMasterBranch()">Copy From Master Branch</button>
                                            <button class="btn btn-primary" type="button" v-on:click="addNewCategory()">Add New Menu Category</button>
                                        </div>
                                    </li>
                                    <li v-for="(mCategory, indexMenuCategory) in menu" v-bind:key="indexMenuCategory">
                                      <div class="row">
                                        <div class="col-md-7">
                                          <h3 v-bind:id="'m_category_' + indexMenuCategory">
                                            <b class="text-success">Menu Category: {{mCategory.name}}</b>
                                            <i v-if="mCategory.baykedExclusiveDeal && validDealCategory"
                                            style="color: red;">&emsp;[Deal]</i>
                                          </h3>
                                        </div>
                                        <div v-if="!validDealCategory" class="checkbox col-md-2">
                                          <label>
                                            <input type="checkbox"
                                                        v-model="mCategory.baykedExclusiveDeal"
                                            /> deal?</label>
                                        </div>
                                        <div v-if="!$store.getters.isDVMportal" class="col-md-3 pull-right" style="padding-right: 30px; padding-bottom: 15px">
                                          <multiselect :id= 'mCategory.id + "_brands"'
                                                       v-model="mCategory.brandsByBrandsId"
                                                       :options="allBrands"
                                                       label="name"
                                                       track-by="name"
                                                       placeholder="Select Brands"
                                          ></multiselect>
                                        </div>
                                      </div>
                                        <div class="row">
                                            <div :class="isBabyHugPortal ? 'col-md-5' : 'col-md-8'">
                                                <input v-model="mCategory.id" type="hidden" />
                                                <div class="input-group m-b">
                                                    <span class="input-group-addon"><a title="Add New Menu Item" class="myTip"  v-on:click="addNewMenuItem(mCategory.menuItemsById, indexMenuCategory)"><i class="fa fa-plus"></i></a></span>
                                                    <span class="input-group-addon" v-if="mCategory.id === 0"><a class="myTip" title="Remove This Category" v-on:click="removeFromObject(indexMenuCategory, menu)"><i class="fa fa-times"></i></a></span>
                                                    <input v-model="mCategory.name" spellcheck="true" :disabled="mCategory.id!==0  && (loggedInUserRole!=='ROLE_ADMIN' && loggedInUserRole!=='ROLE_MANAGER')" type="text" class="form-control" placeholder="Menu Category ..." />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                              <input v-model="mCategory.priority" type="number" size="2" min="0" class="form-control" placeholder="Prority" />
                                            </div>
                                          <div class="col-md-3" v-if="isBabyHugPortal">
                                            <div class="input-group">
                                              <input v-model="mCategory.sale" type="number" title="Add discount on all menu items" min="0" max="100" class="form-control" placeholder="discount ..." />
                                              <span class="input-group-addon"><b>%</b></span>
                                              <span class="input-group-btn">
                                                <button type="button" @click="applyDiscountOnAllMenuItem(mCategory.menuItemsById, mCategory.sale)" class="btn btn-primary"><i class="fa fa-check" ></i></button>
                                              </span>
                                            </div>
                                          </div>
                                            <div class="col-md-2 style-buttons" v-if="mCategory.id > 0">
                                                <a v-if="loggedInUserRole === 'ROLE_ADMIN' || loggedInUserRole === 'ROLE_MANAGER'">
                                                  <i class="fa fa-trash-o fa-lg"
                                                     title="Delete"
                                                     @click="deleteMenuCategory(mCategory.id, mCategory.menuItemsById, indexMenuCategory, menu)"
                                                  /> |
                                                </a>
                                                <a @click="mCategory.deleted = !mCategory.deleted">
                                                  <i v-if="!mCategory.deleted"
                                                     class="fa fa-toggle-on fa-lg"
                                                     title="Enabled"
                                                  />
                                                  <i v-else
                                                     class="fa fa-toggle-off fa-lg"
                                                     title="Disabled"
                                                  />
                                                </a>

                                              </div>
                                        </div>
                                        <ul class="list-unstyled">
                                            <li v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-bind:key="indexMenuItem">
                                                <div class="row" v-bind:id="'menu_item_head_' + indexMenuCategory+'_'+indexMenuItem">
                                                    <div class="col-md-8">
                                                        <h4>Menu Item # {{indexMenuItem+1}} => {{menuItem.name}}</h4>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                  <div class="checkbox col-md-3">
                                                    <label><input type="checkbox" v-model="menuItem.mostPopular" />Most Popular</label>
                                                  </div>
                                                  <div class="checkbox col-md-3">
                                                    <label><input type="checkbox" v-model="menuItem.disableOnBayked" />Disable On {{$store.getters.getValidPlatform}}</label>
                                                  </div>
                                                </div>
                                                <div class="row">
                                                    <div :class="isBabyHugPortal ? 'col-md-4' : 'col-md-5'">
                                                        <input v-model="menuItem.id" type="hidden" />
                                                        <div class="input-group m-b">
                                                            <span class="input-group-addon"><a title="Assign Ad-On Category" class="myTip"  v-on:click="addNewMenuItemAdOnCategory(menuItem.menuItemAdOns)"><i class="fa fa-cart-plus"></i></a></span>
                                                            <span class="input-group-addon"><a title="Add New Serving" class="myTip"  v-on:click="addNewMenuItemType(menuItem.menuItemTypesById)"><i class="fa fa-plus"></i></a></span>
                                                            <span class="input-group-addon" v-if="menuItem.id === 0"><a class="myTip" title="Remove This Item" v-on:click="removeFromObject(indexMenuItem, mCategory.menuItemsById)"><i class="fa fa-times"></i></a></span>
                                                            <input spellcheck="true" v-model="menuItem.name" :disabled="menuItem.id!==0 && (loggedInUserRole!=='ROLE_ADMIN' && loggedInUserRole!=='ROLE_MANAGER')" type="text" class="form-control" placeholder="Menu Item ..." />
                                                        </div>
                                                    </div>
                                                    <div :class="isBabyHugPortal ? 'col-md-4' : 'col-md-5'" style="padding-bottom: 7px;">
                                                        <textarea v-model="menuItem.description"
                                                                  spellcheck="true"
                                                                  type="text"
                                                                  class="fm-t-md style-textarea" rows="2"
                                                                  placeholder="Menu Item Description ..." />
                                                    </div>
                                                  <div class="col-md-2" v-if="isBabyHugPortal">
                                                    <div class="input-group">
                                                      <input v-model="menuItem.sale" title="Add discount on item" type="number" min="0" max="100" class="form-control" placeholder="discount ..." />
                                                      <span class="input-group-addon"><b>%</b></span>
                                                    </div>
                                                  </div>
                                                    <div class="col-md-2 style-buttons" v-if="menuItem.id > 0 && (loggedInUserRole === 'ROLE_ADMIN' || loggedInUserRole === 'ROLE_MANAGER')">
                                                      <a v-if="loggedInUserRole === 'ROLE_ADMIN' || loggedInUserRole === 'ROLE_MANAGER'">
                                                        <i class="fa fa-trash-o fa-lg"
                                                           title="Delete"
                                                           @click="deleteItem(menuItem.id, menuItem.menuItemTypesById, indexMenuItem, mCategory.menuItemsById)"
                                                        /> |
                                                      </a>
                                                      <a @click="menuItem.deleted = !menuItem.deleted">
                                                        <i v-if="!menuItem.deleted"
                                                           class="fa fa-toggle-on fa-lg"
                                                           title="Enabled"
                                                        />
                                                        <i v-else
                                                           class="fa fa-toggle-off fa-lg"
                                                           title="Disabled"
                                                        />
                                                      </a>

                                                    </div>
                                                </div>
                                                <ul class="list-unstyled">
                                                    <li v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-bind:key="indexMenuItemType">
                                                        <div class="row">
                                                            <div class="col-md-4 col-md-offset-1">
                                                                <input v-model="menuItemType.id" type="hidden" />
                                                                <div class="input-group m-b">
                                                                    <span class="input-group-addon" v-if="menuItemType.id === 0"><a v-on:click="removeFromObject(indexMenuItemType, menuItem.menuItemTypesById)"><i class="fa fa-times"></i></a></span>
                                                                    <span class="input-group-addon"><a title="Assign Menu Item Type Ad-On Category" class="myTip"  v-on:click="addNewMenuItemAdOnCategory(menuItemType.menuItemTypeAdOns)"><i class="fa fa-cart-plus"></i></a></span>
                                                                    <input v-model="menuItemType.serving" spellcheck="true" :disabled="menuItemType.id!==0 && (loggedInUserRole!=='ROLE_ADMIN' && loggedInUserRole!=='ROLE_MANAGER')" type="text" class="form-control" placeholder="Serving ..." />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <input v-model="menuItemType.price" type="number" class="form-control" placeholder="Serving Price ..." />
                                                            </div>
                                                            <div class="col-md-3 style-buttons" v-if="menuItemType.id > 0">
                                                              <a v-if="loggedInUserRole === 'ROLE_ADMIN' || loggedInUserRole === 'ROLE_MANAGER'">
                                                                <i class="fa fa-trash-o fa-lg"
                                                                   title="Delete"
                                                                   @click="deleteMenuItemType(menuItemType.id, indexMenuItemType, menuItem.menuItemTypesById)"
                                                                /> |
                                                              </a>
                                                              <a @click="menuItemType.deleted = !menuItemType.deleted">
                                                                <i v-if="!menuItemType.deleted"
                                                                   class="fa fa-toggle-on fa-lg"
                                                                   title="Enabled"
                                                                />
                                                                <i v-else
                                                                   class="fa fa-toggle-off fa-lg"
                                                                   title="Disabled"
                                                                />
                                                              </a>
                                                            </div>
                                                        </div>
                                                        <ul class="list-unstyled col-md-offset-2">
                                                            <li v-for="(menuItemTypeAdOn, indexMenuItemTypeAdOn) in menuItemType.menuItemTypeAdOns">
<!--                                                                <b>{{menuItemTypeAdOn.addOnCategory.name}}</b>-->
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <h4>Assigned Menu Item Type Ad-On {{indexMenuItemTypeAdOn + 1}}</h4>
                                                                        <input v-model="menuItemTypeAdOn.id" type="hidden" />
                                                                        <div class="input-group m-b">
                                                                            <span class="input-group-addon" v-if="menuItemTypeAdOn.id === 0"><a v-on:click="removeFromObject(indexMenuItemTypeAdOn, menuItemType.menuItemTypeAdOns)"><i class="fa fa-times"></i></a></span>
                                                                            <select class="form-control"  v-model="menuItemTypeAdOn.addOnCategory.id">
                                                                                <option value="0" disabled>Select Ad On Category</option>
                                                                                <option v-for="adOnCategory in adOnCategories" v-bind:key="adOnCategory.id" v-bind:value="adOnCategory.id">{{adOnCategory.name}}</option>
                                                                            </select>
                                                                          <span class="input-group-addon style-buttons" v-if="menuItemTypeAdOn.id>0 && (loggedInUserRole === 'ROLE_ADMIN' || loggedInUserRole === 'ROLE_MANAGER')">
                                                                            <a>
                                                                              <label @click="removeAddOnWithMenuItemType(menuItemTypeAdOn.id, indexMenuItemTypeAdOn, menuItemType.menuItemTypeAdOns)">De-Link add-on category</label>
                                                                            </a>
                                                                          </span>
                                                                          <span class="input-group-addon style-buttons" v-if="menuItemTypeAdOn.id>0 && (loggedInUserRole === 'ROLE_ADMIN' || loggedInUserRole === 'ROLE_MANAGER')">
                                                                            <input type="checkbox" disabled v-model="menuItemType.deleted"/> Disabled
                                                                          </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </li>

                                                </ul>
                                                <ul class="list-unstyled">
                                                    <li v-for="(adOns, indexMenuAdOnCategory) in menuItem.menuItemAdOns" v-bind:key="indexMenuAdOnCategory">
                                                        <div class="row">
                                                            <div class="col-md-6 col-md-offset-1">
                                                                <h4>Assigned Ad-On {{indexMenuAdOnCategory + 1}}</h4>
                                                                <input v-model="adOns.id" type="hidden" />
                                                                <div class="input-group m-b">
                                                                    <span class="input-group-addon" v-if="adOns.id === 0"><a v-on:click="removeFromObject(indexMenuAdOnCategory, menuItem.menuItemAdOns)"><i class="fa fa-times"></i></a></span>
                                                                    <select class="form-control"  v-model="adOns.addOnCategory.id">
                                                                        <option value="0" disabled>Select Ad On Category</option>
                                                                        <option v-for="adOnCategory in adOnCategories" v-bind:key="adOnCategory.id" v-bind:value="adOnCategory.id">{{adOnCategory.name}}</option>
                                                                    </select>
                                                                    <span class="input-group-addon style-buttons" v-if="adOns.id>0 && (loggedInUserRole === 'ROLE_ADMIN' || loggedInUserRole === 'ROLE_MANAGER')">
                                                                      <a>
                                                                        <label @click="removeAddOnWithMenuItem(adOns.id, indexMenuAdOnCategory, menuItem.menuItemAdOns)">De-Link add-on category</label>
                                                                      </a>
                                                                    </span>
                                                                    <span class="input-group-addon style-buttons" v-if="adOns.id>0 && (loggedInUserRole === 'ROLE_ADMIN' || loggedInUserRole === 'ROLE_MANAGER')">
                                                                      <input type="checkbox" disabled v-model="adOns.deleted"/> Disabled
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div class="c_dash"></div>
                                            </li>
                                        </ul>
                                        <hr/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import ViewMenuItemImages from "./ViewMenuItemImages";
    import MenuValidation from "../../Mixins/MenuValidation";
    import {fetchAllBrands} from "@/api/brands";
    import Multiselect from "vue-multiselect";

    export default {
      name: "AddUpdateMenu",
      components: {ViewMenuItemImages, Multiselect},
      mixins: [MenuValidation],
      data() {
        return {
          menu: [],
          branchId: 0,
          categorySale: 0,
          branchName: '',
          restaurantId: 0,
          adOnCategories: [],
          uploadImages: false,
          isHideSpinner: "hide",
          validDealCategory: false,
          allBrands: []
        }
      },
      updated: function () {
        $(".myTip").tooltip({
          placement: "right"
        });
      },
      mounted: function () {
        $("#branch_menu_modal").on('hidden.bs.modal', (e) => {
          this.menu = [];
        });
      },
      computed: {
        loggedInUserRole() {
          return this.$store.getters.user.userRolesById[0].role
        },
        isBabyHugPortal() {
          return !this.$store.getters.isDVMportal
        }
      },
      methods: {
        load: async function (branchId, restaurantId, branchName) {
            this.branchId = branchId;
            this.restaurantId = restaurantId;
            this.branchName = branchName;
            let params = new URLSearchParams();
            params.append("restaurant_id", restaurantId);

            await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_ad_on_categories", params).then(resp => {
                this.adOnCategories = resp.data;
            });

            let params2 = new URLSearchParams();
            params2.append("branch_id", branchId);

            await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_branch_menu", params2).then(resp => {
                this.menu = resp.data;
                for (let i = 0; i < this.menu.length; i++) {
                    this.menu[i].branchesByBranchId = {
                        id: branchId
                    }
                }
                this.checkIfDealAndItsConfiguration();
                if (!this.$store.getters.isDVMportal) {
                    this.fetchAllBrands()
                }

            });
            console.log("Menu loaded in AddUpdateMenu", this.menu);
            setTimeout(()=>{
                $("#branch_menu_modal").modal("show");
            }, 200)

        },
        fetchAllBrands: async function () {
          let allMenuItemCategoriesResp = await fetchAllBrands().catch(ex =>{
            this.showErrorMessage(ex);
          });
          if(allMenuItemCategoriesResp.data.status === 200){
            this.allBrands = allMenuItemCategoriesResp.data.body;
          }else{
            this.showErrorMessage(allMenuItemCategoriesResp.data.message)
          }
        },
        checkIfDealAndItsConfiguration: async function () {
          this.validDealCategory = this.menu.find(menuCategory => {
            return menuCategory.baykedExclusiveDeal === true
          });
        },
        copyFromMasterBranch: function () {
          this.isHideSpinner = "";
          let params2 = new URLSearchParams();
          params2.append("branch_id", this.branchId);
          params2.append("restaurant_id", this.restaurantId);
          this.$http.post(this.$store.state.mainAppURL + "restaurants/copy_from_master_branch", params2).then(resp => {
            console.log(resp.data);
            if (resp.data === "") {
              swal("Error!", "No Master Branch Exist or This branch already has menu! Please try again or contact DVM Tech Support.", "error");
            } else {
              this.menu = resp.data;
              for (let i = 0; i < this.menu.length; i++) {
                this.menu[i].branchesByBranchId = {
                  id: this.branchId
                }
              }
            }

            this.isHideSpinner = "hide";
          });
        },
        async applyDiscountOnAllMenuItem(menuItems, val) {
          let applyDiscount = await this.confirmFromUserBeforeApplingDiscountOnAllMenuItem("Are you sure you want to apply discount on all menu items?")
          if (applyDiscount.value) {
            menuItems.map(menuItem => menuItem.sale = val ? val : 0)
          }
        },
        addNewCategory: function () {
          let newCategory = {
            id: 0,
            name: "",
            deleted: false,
            priority: 0,
            branchesByBranchId: {
              id: this.branchId
            },
            menuItemsById: []
          };
          this.menu.push(newCategory);
          let lastIndex = this.menu.length - 1;
          setTimeout(function () {
            $('#menu_item_box').animate({
              scrollTop: $("#m_category_" + lastIndex).offset().top - 100
            }, 1000);
          }, 300);

        },
        addNewMenuItem: function (object, indexMenuCategory) {
          let newMenuItem = {
            id: 0,
            name: "",
            description: "",
            deleted: false,
            menuItemTypesById: [],
            menuItemAdOns: []
          };
          object.push(newMenuItem);
          let lastIndex = this.menu[indexMenuCategory].menuItemsById.length - 1;
          setTimeout(function () {
            let box = $('#menu_item_box');
            box.animate({
              scrollTop: $("#menu_item_head_" + indexMenuCategory + "_" + lastIndex).offset().top + box.scrollTop() - 100
            }, 1000);
          }, 300);
        },
        addNewMenuItemType: function (object) {
          let newItemType = {
            id: 0,
            serving: "",
            price: 0,
            deleted: false,
            menuItemTypeAdOns: []
          };
          object.push(newItemType);
        },
        addNewMenuItemAdOnCategory: function (object) {
          let menuItemAdOnCategory = {
            id: 0,
            addOnCategory: {
              id: 0
            }

          };
          object.push(menuItemAdOnCategory);
        },
        removeFromObject: function (index, object) {
          object.splice(index, 1);
        },
        goToGivenCategory: function (categoryIndex) {
          let box = $('#menu_item_box');
          box.animate({
            scrollTop: $("#m_category_" + categoryIndex).offset().top + box.scrollTop() - 100
          }, 1000);
        },
        isValidMenuItem: function (menuItem) {
          if(menuItem.menuItemTypesById.length === 0){
            swal("INVALID DATA!", "Kindly add servings against menu item: " + menuItem.name + "!", "error");
            return false;
          }
          for (const menuItemTypes of menuItem.menuItemTypesById) {
            if (menuItemTypes.serving === '') {
              swal("INVALID DATA!", "Invalid servings of menu item: " + menuItem.name + "!", "error");
              return false;
            }
            for (const menuItemTypeAdOns of menuItemTypes.menuItemTypeAdOns) {
              if (menuItemTypeAdOns.addOnCategory.id === 0 || menuItemTypeAdOns.addOnCategory.id === "") {
                swal("INVALID DATA!", "Please select valid add-ons with serving " + menuItemTypes.serving + " of menu item: " + menuItem.name, "error");
                return false;
              }
            }

          }
          for (let menuItemsAdOns of menuItem.menuItemAdOns) {
            if (menuItemsAdOns.addOnCategory.id === 0 || menuItemsAdOns.addOnCategory.id === "") {
              swal("INVALID DATA!", "Please select valid menu item add-ons of menu item " + menuItem.name + "!", "error");
              return false;
            }
          }
          return true;
        },
        isValidMenuCategory: function (menuCategory) {
          for (let menuItem of menuCategory.menuItemsById) {
            if (menuItem.name === '') {
              swal("INVALID DATA!", "Menu Item name is empty in " + menuCategory.name + " Menu Category!", "error");
              return false;
            }
            if (!this.isValidMenuItem(menuItem)) {
              return false;
            }
          }
          return true;
        },
        isValidBranchMenuToSaveAndUpdate: function () {
          let countBaykedExclusiveDeal = 0;
          for (let menuCategory of this.menu) {
            if (menuCategory.baykedExclusiveDeal && ++countBaykedExclusiveDeal > 1) {
              swal("INVALID DATA!", "Only one menu category can be mark as DEAL!", "error");
              return false;
            }
            if (menuCategory.menuItemsById.length === 0 || menuCategory.name === '') {
              swal("INVALID DATA!", (menuCategory.name === '') ? "Menu Category name is empty!" : "Kindly add menu items in menu category: " + menuCategory.name, "error");
              return false;
            }
            if (!this.isValidMenuCategory(menuCategory)) {
              return false;
            }
          }
          return true;
        },
        updateBranchMenu: function () {
          if (this.isValidBranchMenuToSaveAndUpdate()) {
            Swal.fire({
              title: 'Please Wait! We are processing the data.',
              type: 'info',
              allowOutsideClick: false,
              allowEscapeKey: false,
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });
            this.$http.post(this.$store.state.mainAppURL + "restaurants/add_update_menu", this.menu).then(resp => {
              if (resp.data) {
                $("#branch_menu_modal").modal("hide");
                Swal.close();
                swal("SUCCESS!", "Menu has been added / updated", "success");
                console.log("Menu received by add_update_menu API is", resp.data);
                console.log("Menu updated when API is called: ", this.menu);
                $("#branch_menu_modal").load();
                this.$emit("fetchBranchMenu")
              } else {
                swal("ERROR!", "Please try again or contact DVM Tech Support", "error");
              }
            }).catch(ex => {
              this.showErrorMessage(ex + " You might be adding any add-on category which is deleted. ")
            });
          }
        }
      }
    }
</script>

<style scoped>
  .c_dash{
      margin: 0px auto 15px;
      border-bottom: dashed 1px;
      width: 85%;
  }
  #menu_item_box{
      height: 780px;
      overflow-x: hidden;
      overflow-y: auto;
  }
  #myScrollspy ul li{
      /*padding: 5px;*/
  }
  .checkbox{
    margin-top: 10px !important;
  }
  .style-buttons{
    padding-top: 10px
  }
  .sk-spinner-double-bounce{
    width: 30px;
    height: 30px;
    margin-top: 5px !important;
  }
  #styleFileInputLabel{
    margin-bottom: 10px;
    margin-top: 9px;
  }
  .styleFileInput{
    padding-right: 2px;
  }
  .style-textarea{
    resize: vertical;
    width: 100%;
    padding: 6px;
    height: 37px;
  }
  @media (min-width: 768px) {
    .modal-dialog {
      margin-left: 190px !important;
    }
  }
  @media (min-width: 992px) {
    .modal-dialog {
      width: 90% !important;
    }
    .modal-lg {
      width: 90% !important;
    }
  }
</style>
